import { render, staticRenderFns } from "./BaseOptions.vue?vue&type=template&id=076df335&scoped=true&"
import script from "./BaseOptions.vue?vue&type=script&lang=js&"
export * from "./BaseOptions.vue?vue&type=script&lang=js&"
import style0 from "./BaseOptions.vue?vue&type=style&index=0&id=076df335&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076df335",
  null
  
)

export default component.exports